<template>
  <div
    class="ten-list"
    :class="{
      'ten-list--no-header': !$slots.header && !title,
      'ten-list--no-footer': !$slots.footer,
      'ten-list--multi-columns': columns > 1,
      'ten-list--infinite-scroll': infiniteScroll,
    }"
  >
    <div
      class="ten-list__header"
      v-if="$slots.header || title"
    >
      <slot name="header">
        {{ title }}
      </slot>
    </div>
    <div
      class="ten-list__content"
      v-infinite-scroll="infiniteScroll"
      v-if="infiniteScroll"
    >
      <ten-row
        class="ten-list__row"
        v-for="(row, index) in rows"
        :col-count="columns"
        :gutter="0"
        :key="index"
      >
        <ten-col
          class="ten-list__col"
          v-for="(item, i) in row"
          :key="item.id || i"
          :class="{ ['ten-list__col-' + i]: true }"
        >
          <div class="ten-list__item ">
            <slot
              name="item"
              :item="item"
            >
              <div class="ten-list__item__text">
                <span
                  class="ten-list__item__text-title"
                  v-if="item.title"
                >{{ item.title }}</span>
                <span class="ten-list__item__text-content">{{ item.content }}</span>
              </div>
            </slot>
          </div>
        </ten-col>
      </ten-row>
    </div>
    <div
      class="ten-list__content"
      v-if="!infiniteScroll"
    >
      <ten-row
        class="ten-list__row"
        v-for="(row, index) in rows"
        :col-count="columns"
        :gutter="0"
        :key="index"
      >
        <ten-col
          class="ten-list__col"
          v-for="(item, i) in row"
          :key="item.id || i"
          :class="{ ['ten-list__col-' + i]: true }"
        >
          <div class="ten-list__item ">
            <slot
              name="item"
              :item="item"
            >
              <div class="ten-list__item__text">
                <span
                  class="ten-list__item__text-title"
                  v-if="item.title"
                >{{ item.title }}</span>
                <span class="ten-list__item__text-content">{{ item.content }}</span>
              </div>
            </slot>
          </div>
        </ten-col>
      </ten-row>
    </div>
    <div
      class="ten-list__footer"
      v-if="$slots.footer"
    >
      <slot name="footer" />
    </div>
  </div>
</template>

<script>
import TenRow from '../row/row.vue';
import TenCol from '../col/col.vue';

const name = 'ten-list';

export default {
  name,
  components: {
    TenRow,
    TenCol,
  },
  props: {
    /**
     * 列表的标题，不传不展示 header 部分
     */
    title: {
      type: String,
      default: '',
    },

    /**
     * 列表分多少栏
     */
    columns: {
      type: Number,
      default: 1,
    },

    /**
     * 分栏的时候，元素朝哪个方向排列。
     * row 从左往右排列
     * column 从上往下排列
     */
    direction: {
      type: String,
      default: 'row',
    },

    /**
     * 数据
     */
    data: Array,

    /**
     * 无限下拉加载
     */
    infiniteScroll: Function,
  },
  computed: {
    rows() {
      const { data, columns, direction } = this;
      const rows = [];

      if (direction === 'column') {
        data.forEach((item, i) => {
          const index = i % columns;
          rows[index] = rows[index] || [];
          rows[index].push(item);
        });
      } else {
        const count = Math.ceil(data.length / columns); // 一共多少行
        for (let i = 0; i < count; i++) {
          const row = data.slice(columns * i, (columns * i) + columns);
          rows.push(row);
        }
      }

      return rows;
    },
  },
};
</script>
